module.exports = __webpack_public_path__ + "static/media/MO.59c91c04.svg";